import { first } from 'rxjs/operators';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Stringable, StringableValues } from '../../../../common/stringable.decorator'

import { AppService } from '../../../../services/app.service';

const KEY = 'dossier-alerte-dialog'

@Component({
    selector: 'dossier-alerte-dialog',
    templateUrl: './dossier-alerte-dialog.component.html',
    styleUrls: ['./dossier-alerte-dialog.component.scss']
})

@Stringable({
    path: 'views/partials/layout/dialogs/dossier-alerte-dialog',
    key: KEY,
})

export class DossierAlerteDialogComponent implements OnInit {
	@StringableValues(KEY)
	strings: any
	
    tagTypes: any = [];
    result: any = {
        id: "",
		libelle: '',
        selectedType: {},		
        alerte: {
            id: '',
            tag: '',
            tiers: '',
        }
    };
    showListOfAlerts:boolean;

    constructor(
        public dialogRef: MatDialogRef<DossierAlerteDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private appService: AppService
    ) { };

    ngOnInit(): void {

        this.appService.tagsByTiersType(this.data.type).pipe(first()).subscribe((tagTypes)=>{
            this.tagTypes = tagTypes.result
            this.showListOfAlerts = this.tagTypes.length > 0;
        })
        
    }
    
     hexToRgbA(hex: string, alpha: any = 200) {
        let color;
        let newAlpha = Number.parseInt(alpha);

        if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
            color = hex.substring(1).split('');
            if (color.length == 3) {
                color = [color[0], color[0], color[1], color[1], color[2], color[2]];
            }
            color = '0x' + color.join('');
            return 'rgba(' + [(color >> 16) & 255, (color >> 8) & 255, color & 255].join(',') + ',' + newAlpha / 255 + ')';
        }
    }

}